<template>
  <div class="corpinfo-example">
    <v-dialog v-model="open" title="企业资料应用示例" kind="modal" status="default">
        <v-tabs v-model="selected" align="center">
            <v-tab v-for="(item, index) in tabsList" :key="index" :value="item.value">
                {{ item.label }}
            </v-tab>
        </v-tabs>
        <img :src="require(`../assets/images/example${selected}.png`)">
    </v-dialog>
    <v-button icon="basic_help_line" remote type="text" @click="() => {open = !open}">
        企业资料应用示例
    </v-button>
  </div>
</template>

<script>
const tabsList = [
    {
        value: 1,
        label: '会话窗口',
    },
    {
        value: 2,
        label: '资料卡',
    },
    {
        value: 3,
        label: '搜索面板',
    },
];
export default {
    data() {
        return {
            tabsList,
            selected: 1,
            open: false,
        };
    },
};
</script>
